import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input('appTooltip') tooltipMessage: string;
  tooltip: HTMLElement;
  tooltipTimeout: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltip) {
      this.showTooltip();
    } else {
      clearTimeout(this.tooltipTimeout);
    }
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.scheduleHideTooltip();
  }

  @HostListener('document:click', ['$event']) onDocumentClick(event: MouseEvent) {
    if (this.tooltip && !this.tooltip.contains(event.target as Node) && !this.el.nativeElement.contains(event.target)) {
      this.hideTooltip();
    }
  }

  private showTooltip() {
    this.tooltip = this.renderer.createElement('div');
    this.tooltip.className = 'tooltip-container';

    const tooltipContent = this.renderer.createElement('div');
    tooltipContent.className = 'tooltip-content';
    tooltipContent.innerHTML = this.tooltipMessage;
    this.renderer.appendChild(this.tooltip, tooltipContent);


    const closeButton = this.renderer.createElement('button');
    this.renderer.addClass(closeButton, 'tooltip-close-btn');
    this.renderer.setProperty(closeButton, 'innerHTML', '&times;');
    this.renderer.listen(closeButton, 'click', (event) => {
      event.stopPropagation(); 
      this.hideTooltip();
    });
    this.renderer.appendChild(this.tooltip, closeButton);

    this.renderer.appendChild(document.body, this.tooltip);
    this.positionTooltip();

    this.renderer.setStyle(this.tooltip, 'position', 'absolute');
    this.renderer.setStyle(this.tooltip, 'background', '#e7e7e7');
    this.renderer.setStyle(this.tooltip, 'color', '#000000');
    this.renderer.setStyle(this.tooltip, 'padding', '20px');
    this.renderer.setStyle(this.tooltip, 'borderRadius', '4px');
    this.renderer.setStyle(this.tooltip, 'zIndex', '1000');
    this.renderer.setStyle(this.tooltip, 'maxHeight', '500px');
    this.renderer.setStyle(this.tooltip, 'overflowY', 'auto');
    this.renderer.setStyle(this.tooltip, 'left', `${350}px`);
    this.renderer.setStyle(this.tooltip, 'right', `${350}px`);
    this.renderer.setStyle(this.tooltip, 'fontFamily', 'Roboto, sans-serif');


    this.renderer.setStyle(closeButton, 'position', 'absolute');
    this.renderer.setStyle(closeButton, 'top', '7px');
    this.renderer.setStyle(closeButton, 'right', '7px');
    this.renderer.setStyle(closeButton, 'background', 'transparent');
    this.renderer.setStyle(closeButton, 'border', 'none');
    this.renderer.setStyle(closeButton, 'fontSize', '30px');
    this.renderer.setStyle(closeButton, 'cursor', 'pointer');


    this.renderer.listen(this.tooltip, 'mouseenter', () => {
      clearTimeout(this.tooltipTimeout);
    });
    this.renderer.listen(this.tooltip, 'mouseleave', () => {
      this.scheduleHideTooltip();
    });
  }

  private positionTooltip() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();

    const tooltipHeight = 500;
    const tooltipWidth = this.tooltip.offsetWidth;

    let topPosition = hostPos.bottom + window.scrollY;
    let leftPosition = hostPos.left + window.scrollX;

    if (topPosition + tooltipHeight > window.innerHeight + window.scrollY) {
      topPosition = hostPos.top + window.scrollY - tooltipHeight;
    }

    if (leftPosition + tooltipWidth > window.innerWidth + window.scrollX) {
      leftPosition = window.innerWidth + window.scrollX - tooltipWidth;
    }

    this.renderer.setStyle(this.tooltip, 'top', `${topPosition}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${leftPosition}px`);
  }

  private scheduleHideTooltip() {
    this.tooltipTimeout = setTimeout(() => {
      this.hideTooltip();
    }, 200);
  }

  private hideTooltip() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }
}
